(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-product"] && !Shopify.designMode) return;
  try {
    const selectors = {
    variantSelector: 'variant-selects',
  }

  const bundleProducts = document.querySelectorAll('#bundle-product')
  bundleProducts.forEach((product) => {
    init(product)
  })

  function init(product) {
    let variantData = null
    const variantSelector = product.querySelector(selectors.variantSelector)

    if (variantSelector) {
      variantSelector.addEventListener('change', onVariantChange)

      variantData = JSON.parse(variantSelector.querySelector('script[type="application/json"]').textContent)
    }

    function onVariantChange() {
      // Update product options
      const newOptionVal = variantSelector.querySelector('select').value

      product.setAttribute('data-options', newOptionVal)

      // Get related data
      const relatedData = variantData.find((variant) => {
        return variant.title == newOptionVal
      })

      // Update product ID
      product.setAttribute('data-id', relatedData.id)

      // Update product price
      product.setAttribute('data-price', relatedData.price)
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bundler-build-section"] && !Shopify.designMode) return;
  try {
    const classes = {
    active: 'on',
    hide: 'max-lg:tw-translate-y-full',
  }

  const selectors = {
    wrapper: '[data-hook="bundler-build-section"]',
    toggleAccordion: '[data-hook="toggle-accordion"]',
  }

  const wrappers = document.querySelectorAll(selectors.wrapper)
  wrappers.forEach((wrapper) => {
    init(wrapper)
  })

  function init(wrapper) {
    const cache = {
      toggleAccordion: wrapper.querySelector(selectors.toggleAccordion),
    }

    initEventListeners()
    toggleVisibility()

    function initEventListeners() {
      cache.toggleAccordion.addEventListener('click', toggleAccordion)
      window.addEventListener('scroll', toggleVisibility)
    }

    function toggleAccordion() {
      if (wrapper.classList.contains(classes.active)) {
        wrapper.classList.remove(classes.active)
      } else {
        wrapper.classList.add(classes.active)
      }
    }

    function toggleVisibility() {
      const hideAccordion = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 5

      if (hideAccordion) {
        wrapper.classList.add(classes.hide)
      } else {
        wrapper.classList.remove(classes.hide)
      }
    }
  }
  } catch(e) { console.error(e); }
})();

})();
